import React from 'react';
import pcLogo from '../../../assets/Images/pc-logo.png';

interface AdminPortalHeaderProps {
  className?: string;
}

const AdminPortalHeader: React.FC<AdminPortalHeaderProps> = ({ className = '' }) => {
  const currentDate = new Date();
  const timeString = currentDate.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit',
    hour12: true 
  });

  return (
    <header className={`admin-portal-header ${className}`}>
      <div className="admin-portal-header-left">
        <img 
          src={pcLogo} 
          alt="Pacific Cross Logo" 
          className="admin-portal-logo"
        />
        <h1 className="admin-portal-title">ADMIN PORTAL</h1>
      </div>
      
      <div className="admin-portal-header-right">
        <p className="admin-portal-welcome">Welcome, Admin</p>
        <p className="admin-portal-last-login">Last login: Today, {timeString}</p>
      </div>
    </header>
  );
};

export default AdminPortalHeader;